import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';


const styles = (theme) => ({
  h2: {
    ...theme.typography.hg54b(theme),
  }
});


function Typography(props) {
  const {classes, variant, className} = props;

  if (!variant) return (
    <div className={className}>{props.children}</div>
  );

  if (variant === 'h2') return <h2 className={classNames(className, classes.h2)}>{props.children}</h2>;

}


export default withStyles(styles)(Typography);


// WEBPACK FOOTER //
// ./src/parts/Typography.js